import CollectionPlayer from "./employee/CollectionPlayer"
import globalState from "@/store/globalState"
import util from "@/util"
import Employee from "@/employee/Employee"
import ValueRange from "@/effects/ValueRange"
import { deserialize, identifier, list, object, primitive, raw, serializable } from "serializr"
import EffectType from "@/effects/EffectType"

export default class Research {
  @serializable
  private thumb: string;
  @serializable(identifier())
  public readonly id: string
  @serializable
  public readonly name: string
  @serializable(object(ValueRange))
  public readonly researchCost: ValueRange
  @serializable
  public readonly scienceCost: number
  @serializable
  public readonly equipCost: number
  @serializable
  public readonly ongoingCost: number
  @serializable
  public readonly description: string;
  @serializable(list(primitive()))
  public readonly requires: string[] = []
  @serializable(object(EffectType))
  public readonly effectType: EffectType
  @serializable
  public readonly target: string // employee, farm
  @serializable(raw())
  public readonly effects: any = {}

  @serializable(object(ValueRange))
  public completion: ValueRange
  @serializable
  public isBeingResearched: boolean = false

  constructor(info: any = {}) {
    this.id = (info.id) ? info.id : info.title
    this.name = info.title
    this.thumb = info.thumb
    this.description = info.description
    this.requires = info.requires
    this.researchCost = new ValueRange((info.researchCost) ? info.researchCost : 0, 0)
    this.scienceCost = (info.scienceCost) ? info.scienceCost : 0
    this.equipCost = (info.equipCost) ? info.equipCost : 0
    this.ongoingCost = (info.ongoingCost) ? info.ongoingCost : 0

    // @ts-ignore
    this.effectType = (info.effectType) ? deserialize(EffectType, info.effectType) : new EffectType()
    this.target = info.target

    this.effects = (info.effects) ? info.effects : {}
    this.completion = new ValueRange(0, 0, this.scienceCost)
  }

  load(state: any) {
    this.completion.fraction = state.completion.fraction
    this.isBeingResearched = state.isBeingResearched
  }

  research(dt: number) {
    this.completion.baseValue += dt
  }

  get isCompleted(): boolean {
    return this.completion.fraction >= 1
  }

  get isStarted(): boolean {
    return this.completion.fraction > 0 || this.isBeingResearched
  }

  get image(): string {
    return util.baseUrl() + '/' + this.thumb
  }

  get displayTarget(): string {
    return util.capitalize(this.target)
  }

  get displayPermanence(): string {
    return util.capitalize(this.effectType.permanence)
  }

  get displayDuration(): string {
    let permanence = util.capitalize(this.effectType.permanence)
    if (this.effectType.timeType == 'instant') {
      return `Instant activation`
    } else {
      return `Maximum after ${util.displayTime(this.effectType.duration)}`
    }
  }

  get displayCosts(): string {
    let s = ''
    if (this.equipCost > 0) {
      s += `$${this.equipCost.toFixed(0)} on first equip`
      if (this.ongoingCost > 0) {
        s += ", "
      }
    }
    if (this.ongoingCost > 0) {
      s += `$${(this.ongoingCost * 60).toFixed(0)} / day`
    }
    if (s == '') s = "Free"
    return s
  }

  get isUnequippable(): boolean {
    // Simplest case, if it is instant and permanent, it cannot be unequipped
    if (this.effectType.timeType == 'instant' && this.effectType.permanence == 'permanent') {
      return false
    }
    return true
  }
}
